import React from 'react';
import {MasterLayout} from 'components/layouts';
import {CategoryDetail} from 'components/category-detail';
import title from 'constants/TitlePages.js';

class CategoryDetailPage extends React.Component {

  componentDidMount() {
    document.title = title.CategoryDetailPage;
  }

  render() {
    return (
      <MasterLayout hasBreadcrumb={true}>
        <CategoryDetail params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default CategoryDetailPage;



// WEBPACK FOOTER //
// ./pages/category-detail/CategoryDetailPage.jsx